import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

type Priorities = { urgent: number; high: number; medium: number; low: number };
type SLAData = { sla: { priorities: Priorities } };

const DEFAULT_PRIORITY: SLAData = {
  sla: { priorities: { urgent: 0, high: 0, medium: 0, low: 0 } },
};

@Component({
  selector: "app-service-level-agreement-modal",
  templateUrl: "./service-level-agreement-modal.component.html",
  styleUrls: ["./service-level-agreement-modal.component.sass"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceLevelAgreementModalComponent implements OnInit {
  public priority: SLAData = structuredClone(DEFAULT_PRIORITY);

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: Partial<SLAData> | null
  ) // eslint-disable-next-line no-empty-function
  {}

  ngOnInit(): void {
    if (this.data) {
      const incoming = this.data?.sla?.priorities ?? {};
      this.priority = {
        sla: {
          priorities: {
            ...DEFAULT_PRIORITY.sla.priorities,
            ...incoming,
          },
        },
      };
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
  public submit(): void {
    this.dialogRef.close(this.priority);
  }
}
